// extracted by mini-css-extract-plugin
export var box = "TagsGroup-module--box--38227";
export var box_md = "TagsGroup-module--box_md--3a7dc";
export var box_xmd = "TagsGroup-module--box_xmd--fa541";
export var box_flex = "TagsGroup-module--box_flex--200bd";
export var box_lg = "TagsGroup-module--box_lg--e43da";
export var box_sm = "TagsGroup-module--box_sm--2d498";
export var box_outer = "TagsGroup-module--box_outer--654a2";
export var box_whiteBg = "TagsGroup-module--box_white-bg--1bb62";
export var box_noMarginBottom = "TagsGroup-module--box_no-margin-bottom--d52a1";
export var box_noPadding = "TagsGroup-module--box_no-padding--20cf8";
export var box_outerGray = "TagsGroup-module--box_outer-gray--1c59b";
export var box_dark = "TagsGroup-module--box_dark--ce9fc";
export var box_zIndex = "TagsGroup-module--box_z-index--dc953";
export var box_zIndex6 = "TagsGroup-module--box_z-index-6--92a68";
export var box_eventsWithLine = "TagsGroup-module--box_events-with-line--43905";
export var box_featuresAo = "TagsGroup-module--box_features-ao--17f8d";
export var box_verticalPaddings = "TagsGroup-module--box_vertical-paddings--5efbe";
export var clearP = "TagsGroup-module--clearP--9a1f3";
export var clearP_vc = "TagsGroup-module--clearP_vc--f83c4";
export var wrapper = "TagsGroup-module--wrapper--47b96";
export var tag = "TagsGroup-module--tag--e06f5";
export var disabled = "TagsGroup-module--disabled--d0d3f";
export var fadeInAnimation = "TagsGroup-module--fadeInAnimation--fcc7f";
export var placeHolderShimmer = "TagsGroup-module--placeHolderShimmer--68294";